import React, { useEffect } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input, Select, Textarea } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import {
  getLibraryAchievementTypes,
  getLibraryPenaltyReasonVids,
  getLibrarySeverityLevels,
  getLibraryPhysicalTrainingIndicators,
  getLibrarySpecialistRecordSections,
} from '../../../../actions/library'
import { arrayForSelect } from '../../../../utils/arrayForSelect'
import CustomSelect from '../../../../components/CustomSelect'
import { getTermsList } from '../../../../actions/terms'

const ispenaltyOptions = [
  { name: '', value: '' },
  { name: 'Поощрение', value: 0 },
  { name: 'Наказание', value: -1 },
]

export default function AchieveModal({ data, closeModal, height, addMode, tabType, onSave, onDelete, specialistTerms }) {
  const dispatch = useDispatch()

  const {
    achievementTypes,
    penaltyReasonVids,
    severityLevels,
    physicalTrainingIndicators,
    specialistRecordSections,
  } = useSelector(state => state.library)
  const { schoolYears, } = useSelector(state => state.common)

  useEffect(() => {
    if (tabType === 'achievements' && !achievementTypes?.length) dispatch(getLibraryAchievementTypes())
    if (tabType === 'penalties' && !penaltyReasonVids?.length) dispatch(getLibraryPenaltyReasonVids())
    if (tabType === 'severity' && !severityLevels?.length) dispatch(getLibrarySeverityLevels())
    if (tabType === 'physical_training' && !physicalTrainingIndicators?.length) dispatch(getLibraryPhysicalTrainingIndicators())
    if (tabType === 'specialist_records' && !specialistRecordSections?.length) {
      dispatch(getLibrarySpecialistRecordSections())

    }
  }, [tabType]) // eslint-disable-line

  const needsSchoolYear = tabType === 'physical_training' || tabType === 'severity'

  const { values, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: {
      ...(data || {}),
      ...(needsSchoolYear && !data?.school_year_id && schoolYears?.length
        ? { school_year_id: schoolYears[0].xp_key }
        : {})
    },
    enableReinitialize: true,
    onSubmit: (vals) => {
      if (onSave) onSave(vals)
    }
  })

  const setVal = (name, value) => setFieldValue(name, value)

  const renderTitle = () => {
    const titles = {
      achievements: 'Достижение',
      penalties: 'Поощрение / наказание',
      severity: 'УУД',
      physical_training: 'Физическая подготовка',
      specialist_records: 'Запись специалиста',
    }
    return titles[tabType] || 'Редактировать'
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{ modal: styles.custom }}
    >
      <div className={styles.modalLocal}>
        <h3 className={styles.title}>{renderTitle()}</h3>
        <div className={styles.tabWrapper}>

          {tabType === 'achievements' && (
            <div className={styles.inputsColomn}>
              <Textarea
                label='Достижение'
                name='achievement'
                value={values.achievement || ''}
                onChange={handleChange}
                style={{ width: '500px' }}
              />
              <CustomSelect
                title='Тип достижения'
                valuesName='type_id'
                value={values.type_id || ''}
                options={arrayForSelect(achievementTypes || [], 'name', 'id')}
                setFieldValue={setVal}
                withoutAll
              />
              <Input
                label='Дата'
                type='date'
                name='date'
                value={values.date || ''}
                onChange={handleChange}
              />
              <Input
                label='Номер приказа'
                name='ordering'
                value={values.ordering || ''}
                onChange={handleChange}
              />
            </div>
          )}

          {tabType === 'penalties' && (
            <div className={styles.inputsColomn}>
              <CustomSelect
                title='Поощрение / наказание'
                valuesName='ispenalty'
                value={values.ispenalty ?? ''}
                options={arrayForSelect(ispenaltyOptions, 'name', 'value')}
                setFieldValue={setVal}
                withoutAll
              />
              <Input
                label='Дата'
                type='date'
                name='datepenatly'
                value={values.datepenatly || ''}
                onChange={handleChange}
              />
              <CustomSelect
                title='Вид'
                valuesName='reason_vid'
                value={values.reason_vid || ''}
                options={(penaltyReasonVids || []).map(r => ({ name: r.value || r, value: r.value || r }))}
                setFieldValue={setVal}
                withoutAll
              />
              <Textarea
                label='Содержание'
                name='reason'
                value={values.reason || ''}
                onChange={handleChange}
                style={{ width: '500px' }}
              />
              <Input
                label='Кто вынес'
                name='whogave'
                value={values.whogave || ''}
                onChange={handleChange}
              />
              <Input
                label='Снято'
                name='cleared'
                value={values.cleared || ''}
                onChange={handleChange}
              />
              <Input
                label='Дата окончания'
                type='date'
                name='dateendpenatly'
                value={values.dateendpenatly || ''}
                onChange={handleChange}
              />
            </div>
          )}

          {tabType === 'severity' && (
            <div className={styles.inputsColomn}>
              <CustomSelect
                title='Уровень'
                valuesName='severity_level_id'
                value={values.severity_level_id || ''}
                options={arrayForSelect(severityLevels || [], 'name', 'id')}
                setFieldValue={setVal}
                withoutAll
              />
              <CustomSelect
                title='Учебный год'
                valuesName='school_year_id'
                value={values.school_year_id || ''}
                options={arrayForSelect(schoolYears || [], 'name', 'xp_key')}
                setFieldValue={setVal}
                withoutAll
              />
            </div>
          )}

          {tabType === 'physical_training' && (
            <div className={styles.inputsColomn}>
              <CustomSelect
                title='Показатель'
                valuesName='indicator_id'
                value={values.indicator_id || ''}
                options={arrayForSelect(physicalTrainingIndicators || [], 'iname', 'iid')}
                setFieldValue={setVal}
                withoutAll
              />
              <Input
                label='Значение'
                name='value'
                value={values.value || ''}
                onChange={handleChange}
              />
              <Input
                label='Дата измерения'
                type='date'
                name='taken'
                value={values.taken || ''}
                onChange={handleChange}
              />
              <CustomSelect
                title='Учебный год'
                valuesName='school_year_id'
                value={values.school_year_id || ''}
                options={arrayForSelect(schoolYears || [], 'name', 'xp_key')}
                setFieldValue={setVal}
                withoutAll
              />
            </div>
          )}

          {tabType === 'specialist_records' && (
            <div className={styles.inputsColomn}>
              <CustomSelect
                title='Четверть'
                valuesName='trmid'
                value={values.trmid || ''}
                options={(specialistTerms || []).map(t => ({ name: t.term_name, value: t.trmid }))}
                setFieldValue={setVal}
                withoutAll
              />
              {console.log('specialistRecordSections::: ', specialistRecordSections)}
              <CustomSelect
                title='Раздел'
                valuesName='section_id'
                value={values.section_id || ''}
                options={arrayForSelect(specialistRecordSections || [], 'name', 'id')}
                setFieldValue={setVal}
                withoutAll
              />
              <Textarea
                label='Содержание'
                name='content'
                value={values.content || ''}
                onChange={handleChange}
                style={{ width: '500px' }}
              />
              <Textarea
                label='Родителям'
                name='content2'
                value={values.content2 || ''}
                onChange={handleChange}
                style={{ width: '500px' }}
              />
              <Textarea
                label='Преподавателям'
                name='for_teachers'
                value={values.for_teachers || ''}
                onChange={handleChange}
                style={{ width: '500px' }}
              />
              <Textarea
                label='Воспитателям'
                name='for_tutors'
                value={values.for_tutors || ''}
                onChange={handleChange}
                style={{ width: '500px' }}
              />
            </div>
          )}

        </div>
      </div>

      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
    </Modal>
  )
}
